export default {"src":"/encomendas-static/_next/static/media/step-pay.f860a8b3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};